import { Container, Form, Row, Col, Button, Dropdown } from "react-bootstrap";
import React, { useEffect, useState } from "react";



import "../../../App.css";
import SideMenu from "../../../Components/SideDrawer";
import PageHeader from "../../../Components/Header";
import { companyGet, driverPayrollPost, employeePayrollPost } from "../../../Api/Admin/AdminApi";
import { extractErrorMessage } from "../../../Utils/ErrorUtlis";

const Payroll = () => {
  const [selectedOption, setSelectedOption] = useState("worker");
  const [selectedDate, setSelectedDate] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  });
  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [loadingCompany, setLoadingComapany] = useState(false);

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setCompany(companies);
          setLoadingComapany(true);
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }
      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    };
    fetchCompany();
  }, []);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
    console.log(`Selected Option: ${selectedOption}`);

  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setSelectedDate(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePayrollRun = () => {
    const driverPayroll = async () => {
      try {
        const response = await driverPayrollPost(JSON.stringify(payrollgenerate));
        if (response) {
          alert("Driver Payroll Generated Successfully...")
        }
      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }

    const workerPayroll = async () => {
      try {
        const response = await employeePayrollPost(JSON.stringify(payrollgenerate));
        if (response) {
          alert("Worker Payroll Generated Successfully....")
        }
      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    // Format the date as yyyy-mm
    const formattedDate = `${selectedDate.year}-${String(selectedDate.month).padStart(2, '0')}`;

    console.log("Payroll run initiated for:", {
      type: selectedOption,
      company: selectedCompany.id,
      period: formattedDate
    });
    const payrollgenerate = { payMonth: formattedDate, companyId: selectedCompany.id }
    console.log(`Payroll Generate Data: ${JSON.stringify(payrollgenerate)}`);
    if (selectedOption) {
      switch (selectedOption) {
        case "driver":
          return driverPayroll();
        case "worker":
          return workerPayroll();
        default:
          console.log('No Option matched');
      }
    } else {
      console.log('Payroll Type Not selected');
      alert('Select the payroll Type to generate a payroll')
    }


  };

  // Generate years (current year ± 5)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);

  // Months data
  const months = [
    { value: 1, name: "January" },
    { value: 2, name: "February" },
    { value: 3, name: "March" },
    { value: 4, name: "April" },
    { value: 5, name: "May" },
    { value: 6, name: "June" },
    { value: 7, name: "July" },
    { value: 8, name: "August" },
    { value: 9, name: "September" },
    { value: 10, name: "October" },
    { value: 11, name: "November" },
    { value: 12, name: "December" }
  ];

  return (
    <div className="d-flex">
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader
          title="Payroll Generate"
          showButtons={true}
        />

        {/* Radio Button Options (outside form) */}
        <div className="bg-light p-4 rounded-3 mb-4">
          <Form.Group>
            <Form.Label as="legend" className="fw-bold">Select Payroll Type</Form.Label>
            <div className="d-flex gap-4 mt-3">
              <Form.Check
                type="radio"
                label="Worker"
                name="payrollType"
                value="worker"
                checked={selectedOption === "worker"}
                onChange={handleOptionChange}
                id="worker-radio"
              />
              <Form.Check
                type="radio"
                label="Driver"
                name="payrollType"
                value="driver"
                checked={selectedOption === "driver"}
                onChange={handleOptionChange}
                id="driver-radio"
              />
            </div>
          </Form.Group>
        </div>

        <Form>
          <Row>
            <Col md={6}>
              {/* Month/Year Picker (inside form) */}
              <div className="bg-light p-4 rounded-3 mb-4 h-100">
                <Form.Group>
                  <Form.Label className="fw-bold">Select Payroll Period</Form.Label>
                  <Row className="mt-3 g-3">
                    <Col md={6}>
                      <Form.Select
                        name="month"
                        value={selectedDate.month}
                        onChange={handleDateChange}
                        className="form-select-lg"
                      >
                        {months.map((month) => (
                          <option key={month.value} value={month.value}>
                            {month.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    <Col md={6}>
                      <Form.Select
                        name="year"
                        value={selectedDate.year}
                        onChange={handleDateChange}
                        className="form-select-lg"
                      >
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                  </Row>
                </Form.Group>
              </div>
            </Col>
            <Col md={6}>
              {/* Company Dropdown (inside form) */}
              <div className="bg-light p-4 rounded-3 mb-4 h-100">
                <Form.Group>
                  <Form.Label className="fw-bold">Select Company</Form.Label>
                  <div className="mt-3">
                    <Dropdown onSelect={(eventKey) => {
                    console.log("Selected Event Key:", eventKey);
                    const selected = company.find(c => c.id == String(eventKey));
                    setSelectedCompany(selected);
                  }}>
                    <Dropdown.Toggle variant="outline-secondary" id="company-dropdown" className="w-100 text-start py-2" style={{ marginTop: '15px'}}>
                      {selectedCompany ? selectedCompany.name : "Select Company"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="w-100">
                      {!loadingCompany ? (
                        <Dropdown.Item disabled>Loading...</Dropdown.Item>
                      ) : (
                        company.map(com => (
                          <Dropdown.Item key={com.id} eventKey={com.id} active={selectedCompany?.id === com.id}>
                            {com.name}
                          </Dropdown.Item>
                        ))
                      )}
                      {console.log(selectedCompany)
                      }
                    </Dropdown.Menu>
                  </Dropdown>
                  </div>
                </Form.Group>
              </div>
            </Col>
          </Row>

          {/* Payroll Run Button (inside form) */}
          <Row className="mt-5">
            <Col className="text-center">
              <Button
                variant="primary"
                size="lg"
                onClick={handlePayrollRun}
                style={{ minWidth: '200px' }}
                type="button"
              >
                Payroll Run
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </div>
  );
};

export default Payroll;